import { evaluateCondition } from "../conditions";
export const evaluateUiCondition = (conditions, contextData, defaultValue) => {
    if (conditions !== undefined) {
        for (const condition of conditions) {
            if (evaluateCondition(condition.condition, contextData) == true) {
                return condition.value;
            }
            else if (condition.condition == "Default") {
                return condition.value;
            }
        }
    }
    return defaultValue === undefined ? "" : defaultValue;
};
//# sourceMappingURL=uiCondition.js.map